export function NotFound() {
  return (
    <div className='h-screen flex justify-center items-center'>
      <h1 className='text-center text-3xl'>
        Page was not found, please try again. If the error still persists,
        report the issue to slack channel #planners-entrypoint-pub.
      </h1>
    </div>
  );
}
